import * as core from '../../../../../../../core'
import * as changeImpactRank from '../change-impact-rank'

export const RESOURCE = {
  payload: {
    description: 'Low',
    enumId: core.dms.models.Enum.Id.from({
      partialId: changeImpactRank.RESOURCE.payload.partialId,
    }),
    id: 'Low',
    name: 'Low',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
